import React from 'react';
import { connect } from 'react-redux';
import {
  Section,
  HighlightsArticleList,
  SixSixArticleList,
  SectionHeader,
  AppContent,
  Ad,
  ErrorBoundary,
} from 'mm-ui-components';
import { Store } from 'redux';
import { Theme } from '../../components/connectedComponents/Theme';
import { MetaTags } from '../../components/connectedComponents/MetaTags';
import { HeadScripts } from '../../components/connectedComponents/HeadScripts';
import { SECTION_NAMES, SLOT_NAMES } from '../templates.const';
import { LoadMoreButton } from '../../components/connectedComponents/LoadMoreButton';
import { Page } from '../Page';
import { getSectionArticlesByKey, getSectionDisplayNameByKey } from '../../store/template/feedPage/feedpage.selectors';
import { HeaderConnected } from '../../components/connectedComponents/HeaderConnected';
import { FooterConnected } from '../../components/connectedComponents/FooterConnected';
import { MainWrapperConnected } from '../../components/connectedComponents/MainWrapperConnected';
import { getAdSlotId } from '../../store/config/config.selectors';
import { ErrorReporter } from '../../errorReporting/errorReporter.type';
import { Article } from '../../store/template/template.state.types';
import { measureHydrateTime } from '../measureHydrateTime';
import { AppState, AppActions, FeedPageAppState } from '../../store/initialStateRegistration';

interface FeedPageProps {
    store: Store<AppState, AppActions>
    errorProvider: ErrorReporter
}

interface FeedPageContentProps {
    topSectionDisplayName: string
    topSectionArticles: Array<Article>,
    cardsSectionDisplayName: string
    cardsSectionArticles: Array<Article>,
    articles: Array<Article>,
    topAdId: string | null
    oneOnOneId: string | null
}

const getArticlesInTemplate = (state:AppState) => {
    const topSectionArticles = getSectionArticlesByKey('topSection')(state) || [];
    const feedSectionArticles = getSectionArticlesByKey('feedSection')(state) || [];
    return [
    ...topSectionArticles,
    ...feedSectionArticles,
    ];
};

export const FeedPageComponent: React.FunctionComponent<FeedPageProps> = ({ store, errorProvider }) => {
    measureHydrateTime();
    return (
      <Page store={store} errorProvider={errorProvider}>
        <ErrorBoundary>
          <FeedPageContentConnected />
        </ErrorBoundary>
      </Page>
  );
};

const mapStateToProps = (state:FeedPageAppState) => ({
  topSectionDisplayName: getSectionDisplayNameByKey(SECTION_NAMES.TOP_SECTION)(state),
  topSectionArticles: getSectionArticlesByKey(SECTION_NAMES.TOP_SECTION)(state),
  cardsSectionDisplayName: getSectionDisplayNameByKey(SECTION_NAMES.FEED_SECTION)(state),
  cardsSectionArticles: getSectionArticlesByKey(SECTION_NAMES.FEED_SECTION)(state),
  articles: getArticlesInTemplate(state),
  topAdId: getAdSlotId(SLOT_NAMES.TOP_AD)(state),
  oneOnOneId: getAdSlotId(SLOT_NAMES.ONE_ON_ONE)(state),
});

const FeedPageContent: React.FunctionComponent<FeedPageContentProps> = (props) => {
  const { topSectionDisplayName, topSectionArticles, cardsSectionDisplayName, cardsSectionArticles, articles, topAdId, oneOnOneId } = props;
  return (
    <React.Fragment>
      <MetaTags articles={articles} />
      <HeadScripts />
      <Theme>
        <AppContent>
          <HeaderConnected />
          <MainWrapperConnected>
            <Ad id={topAdId} />
            <Section>
              <SectionHeader linkText={null} href={null}>
                <h1>{topSectionDisplayName}</h1>
              </SectionHeader>
              <HighlightsArticleList cardsProps={topSectionArticles} />
            </Section>
            <Section>
              <SectionHeader linkText={null} href={null}>
                <h2>{cardsSectionDisplayName}</h2>
              </SectionHeader>
              <SixSixArticleList cardsProps={cardsSectionArticles} />
            </Section>
            <LoadMoreButton sectionKey={SECTION_NAMES.FEED_SECTION} />
            <Ad id={oneOnOneId} />
          </MainWrapperConnected>
          <FooterConnected />
        </AppContent>
      </Theme>
    </React.Fragment>
  );
};

export const FeedPageContentConnected = connect(mapStateToProps)(FeedPageContent);
